module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'أود حفظ هذه البطاقة للمشتريات المستقبلية.',
    cardInfoLabel: '{brand} آخر {lastFour}',
    newCreditCardLabel: 'استخدام بطاقة ائتمان أخرى',
  },
  creditcardButtonMessage: 'الدفع باستخدام بطاقة الائتمان',
  debitcardButtonMessage: 'الدفع باستخدام بطاقة الخصم المباشر',
  externalpayproviderButtonMessage: 'الدفع باستخدام فوري',
  banktransferButtonMessage: 'الدفع بالتحويل المصرفي',
  cardNumberLabel: 'رقم البطاقة',
  methodName: {
    creditcard: 'بطاقة الائتمان',
    debitcard: 'بطاقة الخصم المباشر',
    externalpayprovider: 'فوري',
    paymob: 'محفظة الهاتف المحمول',
  },
  info: {
    paymob: {
      payButton: 'ادفع باستخدام المحفظة الرقمية',
      phoneNumber: 'بعد التأكيد، سيتم توجيهك تلقائيًا إلى محفظتك الرقمية.',
      title: 'ادفع بسهولة بالمحفظة الإلكترونية بتاعتك!',
      description: ' دلوقتي تقدر تدفع من أي محفظة إلكترونية معتمدة من البنك المركزي المصري بكل سهولة وأمان ومن غير أي مجهود، على طول من موبايلك.',
    },
  },
};
